/**
 * Fetches the ApexCharts bundle ahead of the first chart.
 *
 * `ng-apexcharts` loads the library with a dynamic `import('apexcharts/client')` the moment a chart
 * is first created, so the first screen with a chart pays for it after its own route chunk has
 * already arrived: measured on my-dev (dev build) as a third sequential round-trip of 567–911 ms
 * (514 kB gzip; 271 kB in the production build) on the first opening of Plan. Routes that render a
 * chart hand this function to the preloading strategy via `data.warmUp`, and it runs at idle, right
 * after the route's own chunk.
 *
 * `apexcharts` and `apexcharts/client` resolve to the same `dist/apexcharts.esm.js` for the browser,
 * so this lands in the very chunk `ng-apexcharts` will ask for, and the browser dedupes repeated
 * dynamic imports of one module — calling it from several routes costs one fetch.
 */
export const warmUpChartLibrary = (): Promise<unknown> => import('apexcharts');
